<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2026-04-28 11:12:38
 * @LastEditTime: 2026-06-10 09:51:09
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 前期委托-委托管控
 * @FilePath     :  \src\views\platform\ICPS\internetSales\supplyManagement\preCommissioning.vue
-->
<template>
  <!-- 供应管控参数设置 -->
  <el-dialog
    :visible.sync="delegatedControlDig"
    width="1040px"
    :close-on-click-modal="false"
    @open="openSupplySet"
    @close="closeDig" 
  >
    <span slot="title" class="dialog-title">委托管控流程控制</span>
    <div class="tabtop" style="width: 380px">
      <div
        v-for="(item, index) in dataTypeList"
        :key="index"
        @click="choose(item.status)"
      >
        <div :class="dataType == item.status ? 'active' : 'text'">
          {{ item.value }}
        </div>
      </div>
    </div>
    <div v-if="dataType == 1">
      <div class="control-container">
        <el-table
          :data="tableData"
          border
          style="width: 1000px; margin-top: 20px"
          :header-cell-style="{
            background: '#f5f7fa',
            color: '#333',
            fontWeight: 'bold',
          }"
        >
          <el-table-column label="委托类型" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.type }}</span>
            </template>
          </el-table-column>
          <!-- 第一级管控 -->
          <el-table-column label="第一级管控（任一突破即升级）" width="260">
            <template slot-scope="scope">
              <div class="param-group">
                <div class="param-item">
                  <label>单次审批供应时长 ≤</label>
                  <el-input
                    v-model="scope.row.level1.time"
                    type="text"
                    style="width: 80px"
                    @input="(e) => filterInteger(e, scope.row.level1, 'time')"
                  />
                  <span>天</span>
                </div>
                <div class="param-item">
                  <label>单次审批供应量 ≤</label>
                  <el-input
                    v-model="scope.row.level1.volume"
                    type="text"
                    style="width: 80px"
                    @input="(e) => filterInteger(e, scope.row.level1, 'volume')"
                  />
                  <span>m³</span>
                </div>
                <div class="param-item">
                  <label>供应次数 ≤</label>
                  <el-input
                    v-model="scope.row.level1.count"
                    type="text"
                    style="width: 80px"
                    @input="(e) => filterInteger(e, scope.row.level1, 'count')"
                  />
                  <span>次</span>
                </div>
                <div class="param-item">
                  <label>委托累计总量 ≤</label>
                  <el-input
                    v-model="scope.row.level1.totalVolume"
                    type="text"
                    style="width: 80px"
                    @input="(e) => filterInteger(e, scope.row.level1, 'totalVolume')"
                  />
                  <span>m³</span>
                </div>
                <div class="param-item">
                  <label>累计供应时长 ≤</label>
                  <el-input
                    v-model="scope.row.level1.totalTime"
                    type="text"
                    style="width: 80px"
                    @input="(e) => filterInteger(e, scope.row.level1, 'totalTime')"
                  />
                  <span>天</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 第二级管控 -->
          <el-table-column label="第二级管控（任一突破即升级）" width="260">
            <template slot-scope="scope">
              <div class="param-group">
                <div class="param-item">
                  <label>单次审批供应时长 ≤</label>
                  <el-input
                    v-model="scope.row.level2.time"
                    type="text"
                    style="width: 80px"
                    @input="(e) => filterInteger(e, scope.row.level2, 'time')"
                  />
                  <span>天</span>
                </div>
                <div class="param-item">
                  <label>单次审批供应量 ≤</label>
                  <el-input
                    v-model="scope.row.level2.volume"
                    type="text"
                    style="width: 80px"
                    @input="(e) => filterInteger(e, scope.row.level2, 'volume')"
                  />
                  <span>m³</span>
                </div>
                <div class="param-item">
                  <label>供应次数 ≤</label>
                  <el-input
                    v-model="scope.row.level2.count"
                    type="text"
                    style="width: 80px"
                    @input="(e) => filterInteger(e, scope.row.level2, 'count')"
                  />
                  <span>次</span>
                </div>
                <div class="param-item">
                  <label>委托累计总量 ≤</label>
                  <el-input
                    v-model="scope.row.level2.totalVolume"
                    type="text"
                    style="width: 80px"
                    @input="(e) => filterInteger(e, scope.row.level2, 'totalVolume')"
                  />
                  <span>m³</span>
                </div>
                <div class="param-item">
                  <label>累计供应时长 ≤</label>
                  <el-input
                    v-model="scope.row.level2.totalTime"
                    type="text"
                    style="width: 80px"
                    @input="(e) => filterInteger(e, scope.row.level2, 'totalTime')"
                  />
                  <span>天</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 第三级管控 -->
          <el-table-column label="第三级管控" width="260">
            <template slot-scope="scope">
              <div class="param-group">
                <div class="param-item">
                  <label>单次审批供应时长 ≤</label>
                  <el-input
                    v-model="scope.row.level3.time"
                    type="text"
                    style="width: 80px"
                    @input="(e) => filterInteger(e, scope.row.level3, 'time')"
                  />
                  <span>天</span>
                </div>
                <div class="param-item">
                  <label>单次审批供应量 ≤</label>
                  <el-input
                    v-model="scope.row.level3.volume"
                    type="text"
                    style="width: 80px"
                    @input="(e) => filterInteger(e, scope.row.level3, 'volume')"
                  />
                  <span>m³</span>
                </div>
                <div class="param-item">
                  <label>供应次数 ≤</label>
                  <el-input
                    v-model="scope.row.level3.count"
                    type="text"
                    style="width: 80px"
                    @input="(e) => filterInteger(e, scope.row.level3, 'count')"
                  />
                  <span>次</span>
                </div>
                <div class="param-item">
                  <label>委托累计总量 ≤</label>
                  <el-input
                    v-model="scope.row.level3.totalVolume"
                    type="text"
                    style="width: 80px"
                    @input="(e) => filterInteger(e, scope.row.level3, 'totalVolume')"
                  />
                  <span>m³</span>
                </div>
                <div class="param-item">
                  <label>累计供应时长 ≤</label>
                  <el-input
                    v-model="scope.row.level3.totalTime"
                    type="text"
                    style="width: 80px"
                    @input="(e) => filterInteger(e, scope.row.level3, 'totalTime')"
                  />
                  <span>天</span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 预警参数 -->
        <div class="warning-section" style="margin-top: 30px">
          <h4>预警参数设置</h4>
          <el-form :model="warningForm" label-width="180px" size="small">
            <el-form-item label="累计供应总量比例 ≥" required>
              <el-input
                v-model="warningForm.cumulativeRatio"
                type="text"
                style="width: 150px"
                @input="(e) => filterInteger(e, warningForm, 'cumulativeRatio', 0, 100)"
              />
              <span>%</span>
              <span style="margin-left: 10px; font-size: 12px"
                >预警（累计供应总量比例=实际产生累计供应量/委托量）</span
              >
            </el-form-item>
            <el-form-item label="委托期临界值预警 ≤" required>
              <el-input
                v-model="warningForm.warningDays"
                type="text"
                style="width: 150px"
                @input="(e) => filterInteger(e,warningForm,'warningDays')"
              />
              <span>天</span>
              <span style="margin-left: 10px; font-size: 12px"
                >预警（委托期临界值预警=委托期截至时间-定时任务时间）</span
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="closeDig()">关 闭</el-button>
      <el-button class="bottom_all" @click="saveSupplySet">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  querySupplyControlParam,
  updateSupplyControlParam,
} from "@/api/internetSales/supplyManagement.js";
import { getDicType } from "@/api/common.js";

export default {
  props: {
    delegatedControlDig: {
      type: Boolean,
      default: false,
    },
    low: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dataType: 1,
      delegationTypeList: [], // 存储从接口获取的委托类型列表
      tableData: [],
      warningForm: {
        cumulativeRatio: null,
        warningDays: null,
      },
      warningId: null,
      dataTypeList: [
        { value: "常规管控策略", status: 1 },
        { value: "非常规管控策略", status: 0 },
      ],
    };
  },
  methods: {
    // 获取字典
    async loadDelegationTypes() {
        const res = await getDicType({ code: "delegation_type" });
        if (res.code === 1001 && res.data && res.data.items) {
          this.delegationTypeList = res.data.items;
        } else {
          this.$message.error("获取委托类型失败");
          this.delegationTypeList = [];
        }
    },

    filterInteger(value, obj, key, min = 0, max = null) {
      let strVal = String(value || "");
      strVal = strVal.replace(/[^\d]/g, "");
      if (strVal === "") {
        this.$set(obj, key, null);
        return;
      }
      let intVal = parseInt(strVal, 10);
      if (intVal < min) intVal = min;
      if (max !== null && intVal > max) intVal = max;
      this.$set(obj, key, intVal);
    },

    closeDig() {
      this.$emit("closeDig");
    },

    saveSupplySet() {
      const ratio = this.warningForm.cumulativeRatio;
      const days = this.warningForm.warningDays;
      if (ratio === null || ratio === undefined || ratio === "") {
        this.$message.error("请填写预警参数-累计供应总量比例");
        return;
      }
      if (days === null || days === undefined || days === "") {
        this.$message.error("请填写委托期临界值预警天数");
        return;
      }
      // 构建 qwParam 列表
      const qwParamList = [];
      this.tableData.forEach((row) => {
        const levels = [
          { level: 1, data: row.level1 },
          { level: 2, data: row.level2 },
          { level: 3, data: row.level3 },
        ];
        levels.forEach(({ level, data }) => {
          qwParamList.push({
            id: data.id || "",
            delegationType: row.type,
            delegationTypeId: row.delegationTypeId,
            controlLevel: level,
            singleDuration: data.time,
            singleSupply: data.volume,
            supplyFrequency: data.count,
            cumulativeSupply: data.totalVolume,
            cumulativeDuration: data.totalTime,
          });
        });
      });

      const qwWarning = {
        id: this.warningId || "",
        cumulativeSupplyRatio: ratio,
        warningDays: days,
      };

      const params = {
        controlId: this.low.id,
        paramType: this.low.controlTypeVal,
        paramData: { qwWarning, qwParam: qwParamList },
      };

      updateSupplyControlParam(params).then((res) => {
        if (res.code == 1001) {
          this.$message.success("保存成功!");
          this.closeDig();
        }
      });
    },

    async openSupplySet() {
      // 先加载委托类型字典
      await this.loadDelegationTypes();
      // 请求管控参数
      const res = await querySupplyControlParam({
        id: this.low.id,
        controlTypeVal: this.low.controlTypeVal,
      });
      
      if (res.code == 1001) {
        const responseData = res.data?.responseData;
        this.initTableDataFrame();
        
        if (responseData) {
          if (responseData.qwWarning) {
            this.warningId = responseData.qwWarning.id;
            this.warningForm.cumulativeRatio =
              responseData.qwWarning.cumulativeSupplyRatio;
            this.warningForm.warningDays = responseData.qwWarning.warningDays;
          } else {
            this.warningId = null;
            this.warningForm.cumulativeRatio = null;
            this.warningForm.warningDays = null;
          }
          
          const qwParamList = responseData.qwParam || [];
          this.mergeApiDataToTable(qwParamList);
        } else {
          this.warningId = null;
          this.warningForm.cumulativeRatio = null;
          this.warningForm.warningDays = null;
        }
        
        this.dataType = 1;
      }
    },

    // 初始化表格数据结构（基于动态获取的委托类型列表）
    initTableDataFrame() {
      this.tableData = this.delegationTypeList.map((item) => ({
        type: item.itemName,           // 委托类型名称
        delegationTypeId: item.id,     // 委托类型ID
        level1: this.createEmptyLevel(),
        level2: this.createEmptyLevel(),
        level3: this.createEmptyLevel(),
      }));
    },

    mergeApiDataToTable(qwParamList) {
      const rowMap = new Map();
      this.tableData.forEach((row) => {
        rowMap.set(row.type, row);
      });
      
      qwParamList.forEach((apiItem) => {
        const typeName = apiItem.delegationType;
        const row = rowMap.get(typeName);
        if (row) {
          if (apiItem.delegationTypeId) {
            row.delegationTypeId = apiItem.delegationTypeId;
          }
          const levelData = this.mapApiToLevel(apiItem);
          const level = apiItem.controlLevel;
          if (level === 1) row.level1 = levelData;
          else if (level === 2) row.level2 = levelData;
          else if (level === 3) row.level3 = levelData;
        }
      });
    },

    mapApiToLevel(apiItem) {
      return {
        id: apiItem.id,
        time: apiItem.singleDuration,
        volume: apiItem.singleSupply, 
        count: apiItem.supplyFrequency  ,
        totalVolume: apiItem.cumulativeSupply  ,
        totalTime: apiItem.cumulativeDuration  ,
      };
    },

    createEmptyLevel() {
      return {
        id: undefined,
        time: null,
        volume: null,
        count: null,
        totalVolume: null,
        totalTime: null,
      };
    },

    choose(num) {
      this.dataType = num;
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 18px;
  margin: 12px 12px 12px 18px;
}

.text {
  display: flex;
  align-items: center;
}

.control-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.param-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  background: #f9f9f9;
  border-radius: 4px;
}

.param-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.param-item label {
  white-space: nowrap;
  min-width: 100px;
}

.warning-section {
  padding: 20px;
  background: #f5f7fa;
  border-radius: 8px;
  margin-top: 20px;
}
</style>